import { useRef, useState } from 'react';

import { createRequiredContext } from 'src/context/createRequiredContext';

import { type IRoleAndAgreementSettingsForm } from '../ui';

const [useSoftwareEscrowNewContext, SoftwareEscrowNewContext] = createRequiredContext<{
  formRef: React.RefObject<{
    submit: (callback: (data: IRoleAndAgreementSettingsForm) => void) => void;
  } | null>;
  onSubmit: (callback: (data: IRoleAndAgreementSettingsForm) => void) => void;
  isValid: boolean;
  setIsValid: (isValid: boolean) => void;
}>();

const SoftwareEscrowNewContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [isValid, setIsValid] = useState(false);
  const formRef = useRef<{
    submit: (callback: (data: IRoleAndAgreementSettingsForm) => void) => void;
  }>(null);

  const onSubmit = (callback: (data: IRoleAndAgreementSettingsForm) => void) => {
    if (formRef.current) formRef.current.submit(callback);
  };

  const value = { formRef, onSubmit, isValid, setIsValid };

  return <SoftwareEscrowNewContext value={value}>{children}</SoftwareEscrowNewContext>;
};

export { useSoftwareEscrowNewContext, SoftwareEscrowNewContextProvider };
